// This is the entry point for all the "public app"-specific Stimulus Controllers
// This is different than the "admin app" set of controllers

import { application } from "../application"

import { ApplicationController } from "./application_controller"
application.register("application", ApplicationController)

import BottomBarController from "./bottom_bar_controller"
application.register("bottom-bar", BottomBarController)

import NewStripeFlowsDiscountButtonController from "./new_stripe_flows/discount_button_controller"
application.register("new-stripe-flows-discount-button", NewStripeFlowsDiscountButtonController)

import FormController from "./form_controller"
application.register("form", FormController)

import InfiniteScheduleController from './infinite_schedule_controller'
application.register('infinite-schedule', InfiniteScheduleController)

import PaymentsController from "./payments_controller"
application.register("payments", PaymentsController)

import PublicController from "./public_controller"
application.register("public", PublicController)

import PurchaseStatusController from "./purchase_status_controller"
application.register("purchase-status", PurchaseStatusController)

import ScheduleFiltersController from "./schedule_filters_controller"
application.register("schedule-filters", ScheduleFiltersController)

import NavigableDialogController from './navigable_dialog_controller'
application.register("navigable-dialog", NavigableDialogController)
